import { render, staticRenderFns } from "./practise-groups-modal.vue?vue&type=template&id=01339006"
import script from "./practise-groups-modal.vue?vue&type=script&lang=js"
export * from "./practise-groups-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports